import React, { useEffect, useState } from "react";
import Select from "react-select";
import { ReactSortable } from "react-sortablejs";
import DatePicker from "react-datepicker";
import dragHandleIcon from "../assets/images/sideBarIcon1.png";
import { getProjectCheckList, getProjectCheckListImages, updateProjectCheckListImage, downloadUnitJobReport } from "../API";
import FileDownload from "js-file-download";
import { convertToISOString } from "../utils/utils";
import { toast } from "react-toastify";
import Loader from "../pages/Loader";
import { useParams } from "react-router-dom";
import "../assets/styles/report-pages.scss";


const pictureTypeOptions = [
  { label: "before", value: "before" },
  { label: "after", value: "after" },
  { label: "as-built", value: "as-built" },
];

const UnitJobReport = () => {
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [pictures, setPictures] = useState([]);
  const [picturesWithMap, setPicturesWithMap] = useState([]);
  const [originalPictures, setOriginalPictures] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isProjectLoading, setIsProjectLoading] = useState(false);
  const [selectedPictureIds, setSelectedPictureIds] = useState([]);
  const [selectedMapPictureIds, setSelectedMapPictureIds] = useState([]);
  const { project_checklist_id } = useParams();

  const allIds = pictures.map((pic) => pic.id);
  const allMapIds = picturesWithMap.map((pic) => pic.id);

  const allSelected = selectedPictureIds.length === pictures.length && pictures.length > 0;
  const someSelected = selectedPictureIds.length > 0 && selectedPictureIds.length < pictures.length;

  const allMapSelected = selectedMapPictureIds.length === pictures.length && pictures.length > 0;
  const someMapSelected = selectedMapPictureIds.length > 0 && selectedMapPictureIds.length < pictures.length;

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedPictureIds([]);
    } else {
      setSelectedPictureIds(allIds);
    }
  };

  const handleSelectAllMap = () => {
    if (allMapSelected) {
      setSelectedMapPictureIds([]);
    } else {
      setSelectedMapPictureIds(allMapIds);
    }
  };


  useEffect(() => {
    fetchProjectCheckList();
  }, []);

  const fetchProjectCheckList = async () => {
    setIsProjectLoading(true);
    try {
      const query = "status=4&expand=project";
      const response = await getProjectCheckList(query);
      const projectList = response?.data?.map((project) => ({ label: project?.project?.description, value: project.id , project_id: project.project.acumatica_project_id, work_order_number: project.work_order_number}));
      setProjectOptions(projectList);
      if(project_checklist_id){
        const selectedProject = projectList.find((project) => project.value == project_checklist_id)
        setSelectedProject(selectedProject)
        handleSelectProject(selectedProject)
      }
    } catch (error) {
      // Optionally handle error, e.g. toast.warn('Failed to fetch projects')
    } finally {
      setIsProjectLoading(false);
    }
  };

  const handleSelectProject = async (value) => {
    setSelectedPictureIds([]);
    setIsProjectLoading(true);
    try {
      setSelectedProject(value);
      const query = `project_check_list_id=${value?.value}`;
      const response = await getProjectCheckListImages(query);
      // Map API fields to table fields
      const mappedPictures = response?.data?.map((item) => ({
        id: item.id,
        taken_on: item.taken_on,
        type: item.type,
        comment: item.comment,
        image_url: item.image_url,
        sort_order: item.sort_order,
      })) || [];
      const pictureWithoutMap = mappedPictures.filter((pic) => pic.type !== "map");
      const pictureWithMap = mappedPictures.filter((pic) => pic.type === "map");
      setPictures(pictureWithoutMap);
      setPicturesWithMap(pictureWithMap);
      setOriginalPictures(mappedPictures);
      // Pre-select all rows by default
      setSelectedPictureIds(pictureWithoutMap.map((pic) => pic.id));
      setSelectedMapPictureIds(pictureWithMap.map((pic) => pic.id));
    } catch (error) {
      // Optionally handle error, e.g. toast.warn('Failed to fetch project images')
    } finally {
      setIsProjectLoading(false);
    }
  }

  const handlePictureTypeChange = (id, value) => {
    setPictures((prev) =>
      prev.map((pic) =>
        pic.id === id ? { ...pic, type: value.value } : pic
      )
    );
  };

    const handleDescriptionChange = (id, value) => {
      setPictures((prev) =>
        prev.map((pic) =>
          pic.id === id ? { ...pic, comment: value } : pic
        )
      );
    };

  const handleDescriptionChangeForMapPictures = (id, value) => {

    setPicturesWithMap((prev) =>
      prev.map((pic) =>
        pic.id === id ? { ...pic, comment: value } : pic
      )
    );
  };

  const handleDownload = async () => {
    if (!selectedProject || !selectedProject.value) {
      toast.warn("Please select a project before downloading the report.");
      return;
    }
    // if (!pictures || pictures.length === 0) {
    //   toast.warn("No pictures available to download the report.");
    //   return;
    // }
    // if (!selectedPictureIds || selectedPictureIds.length === 0) {
    //   toast.warn("Please select at least one image.");
    //   return;
    // }
    setIsLoading(true);
    try {
      // Find updated pictures by comparing to originalPictures
      const updatedPictures = pictures.filter((pic, idx) => {
        const orig = originalPictures[idx];
        if (!orig) return true;
        return (
          pic.type !== orig.type ||
          pic.description !== orig.description ||
          pic.date !== orig.date ||
          pic.sort_order !== orig.sort_order
        );
      });
      // If there are updates, update each changed picture
      if (updatedPictures.length > 0) {
        for (const pic of updatedPictures) {
          const data = {
            type: pic.type,
            comment: pic.description,
            taken_on: pic.date,
            sort_order: pic.sort_order,
          };
          await updateProjectCheckListImage(pic.id, data);
        }
      }
      // Always download the report
      if (selectedProject?.value) {
        const selectedIdsString = selectedPictureIds.join(',');
        const response = await downloadUnitJobReport(selectedProject.value, selectedIdsString, 'unit');
        if (response && response.data) {
          FileDownload(response.data, `${selectedProject.project_id}_${selectedProject.work_order_number || "no_work_order_number"}_UnitJobReport.pdf`);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadMap = async () => {
    if (!selectedProject || !selectedProject.value) {
      toast.warn("Please select a project before downloading the report.");
      return;
    }
    // if (!pictures || pictures.length === 0) {
    //   toast.warn("No pictures available to download the report.");
    //   return;
    // }
    // if (!selectedPictureIds || selectedPictureIds.length === 0) {
    //   toast.warn("Please select at least one image.");
    //   return;
    // }
    setIsLoading(true);
    try {
      // Find updated pictures by comparing to originalPictures
      const updatedPictures = picturesWithMap.filter((pic, idx) => {
        const orig = originalPictures[idx];
        if (!orig) return true;
        return (
          pic.type !== orig.type ||
          pic.description !== orig.description ||
          pic.date !== orig.date ||
          pic.sort_order !== orig.sort_order
        );
      });
      // If there are updates, update each changed picture
      if (updatedPictures.length > 0) {
        for (const pic of updatedPictures) {
          const data = {
            type: pic.type,
            comment: pic.description,
            taken_on: pic.date,
            sort_order: pic.sort_order,
          };
          await updateProjectCheckListImage(pic.id, data);
        }
      }
      // Always download the report
      if (selectedProject?.value) {
        const selectedIdsString = selectedMapPictureIds.join(',');
        const response = await downloadUnitJobReport(selectedProject.value, selectedIdsString, 'map');
        if (response && response.data) {
          FileDownload(response.data, `${selectedProject.project_id}${selectedProject.work_order_number ? "_" + selectedProject.work_order_number : ""}_Map.pdf`);
        }
      }
    } finally {
      setIsLoading(false);
    }
  }

  const handleDateChange = (date, id) => {
    const isoDate = convertToISOString(date);
    setPictures((prev) =>
      prev.map((pic) => (pic.id === id ? { ...pic, taken_on: isoDate } : pic))
    );
  };

  const handleDateChangeForMapPictures = (date, id) => {
    const isoDate = convertToISOString(date);
    setPicturesWithMap((prev) =>
      prev.map((pic) => (pic.id === id ? { ...pic, taken_on: isoDate } : pic))
    );
  };

  const handleSelectPicture = (id) => {
    setSelectedPictureIds((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const handleSelectPictureMap = (id) => {
    setSelectedMapPictureIds((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const getPlaceHolderText = () => {
    if(isProjectLoading){
      return  "Fetching project images"
    }else if( !selectedProject?.project_id){
      return "Please select a project"
    }else if(!isProjectLoading && pictures.length < 1){
      return "No images in the selected project"
    }else{
      return ""
    }


  }

  return (
    <div className="project-details-page report-page unit-job-report-page">
      {isLoading && <Loader />}
      <div className="project-details-toolbar">
        <h1 className="title project-details-title">Unit Job Report</h1>
      </div>
      <div className="report-card">
        <div className="report-filter-grid">
          <div className="report-field">
            <label className="project-details-field__label">Project</label>
            <Select
              isLoading={isProjectLoading}
              placeholder="Select Project"
              value={selectedProject}
              options={projectOptions}
              onChange={handleSelectProject}
              classNamePrefix="report-select"
            />
          </div>
        </div>
      </div>
      <section className="report-section">
        <div className="report-section-head">
          <h4 className="title project-details-section-title">
            Project Pictures
          </h4>
          <button
            type="button"
            disabled={isLoading}
            className="primary-btn"
            onClick={handleDownload}
          >
            {isLoading ? "Downloading..." : "Download Report"}
          </button>
        </div>
        <div className="table-responsive report-table-wrap">
          <table className="table report-table" style={{ minWidth: 800 }}>
          <thead>
            <tr>
              <th></th>
              <th className="text-center">
                <input
                  className="report-checkbox"
                  type="checkbox"
                  checked={allSelected}
                  ref={el => {
                    if (el) el.indeterminate = someSelected;
                  }}
                  onChange={handleSelectAll}
                />
              </th>
              <th>Order</th>
              <th>Image</th>
              <th>Date</th>
              <th>Picture Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <ReactSortable
            tag="tbody"
            list={pictures}
            setList={(newList) => {
              // Update sort_order for each row based on its new position
              const updated = newList.map((item, idx) => ({ ...item, sort_order: idx + 1 }));
              setPictures(updated);
            }}
            handle=".drag-handle"
            animation={150}
          >
            {
            pictures.map((pic, index) => (
              <tr key={pic.id} data-id={pic.id}>
                <td style={{ width: 32, textAlign: "center", cursor: "grab" }}>
                  <span className="drag-handle">
                    <img src={dragHandleIcon} alt="drag" style={{ width: 20, opacity: 0.7 }} />
                  </span>
                </td>
                <td style={{ width: 32, textAlign: "center" }}>
                  <input
                    className="report-checkbox"
                    type="checkbox"
                    checked={selectedPictureIds.includes(pic.id)}
                    onChange={() => handleSelectPicture(pic.id)}
                  />
                </td>
                <td style={{ width: 50 }}>{index + 1}</td>
                <td style={{ width: 100 }}>
                  {pic.image_url ? (
                    <a href={pic.image_url} target="_blank" rel="noopener noreferrer">
                      <img
                        src={pic.image_url}
                        alt="preview"
                        style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 4, border: '1px solid #ccc' }}
                      />
                    </a>
                  ) : (
                    <span className="text-muted">No Image</span>
                  )}
                </td>
                <td style={{ width: 100 }}>
                  <DatePicker
                    placeholderText="MM/DD/YYYY"
                    selected={pic.taken_on ? new Date(pic.taken_on) : null}
                    onChange={(date) => handleDateChange(date, pic.id)}
                    dateFormat="MM/dd/yyyy"
                    aria-label="Date"
                    className="input-field w-100 mb-0 h-30"
                  />
                </td>
                <td style={{ width: 100 }}>
                  <Select
                    value={pictureTypeOptions.find((opt) => opt.value === pic.type)}
                    options={pictureTypeOptions}
                    onChange={(val) => handlePictureTypeChange(pic.id, val)}
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
                </td>
                <td style={{ width: 400 }}>
                  <textarea
                    style={{
                      resize: 'none', height: '100px', borderRadius: '4px'
                    }}
                    className="form-control "
                    value={pic.comment || ''}
                    onChange={(e) => handleDescriptionChange(pic.id, e.target.value)}
                    rows={1}
                  />
                </td>
              </tr>
            ))
            }
          </ReactSortable>
        </table>
        {getPlaceHolderText() && (
          <div className="report-table-placeholder">{getPlaceHolderText()}</div>
        )}
        </div>
      </section>

      <section className="report-section">
        <div className="report-section-head">
          <h4 className="title project-details-section-title">Map Pictures</h4>
          <button
            type="button"
            disabled={isLoading}
            className="primary-btn"
            onClick={handleDownloadMap}
          >
            {isLoading ? "Downloading..." : "Download Map Report"}
          </button>
        </div>
        <div className="table-responsive report-table-wrap">
        <table className="table report-table" style={{ minWidth: 800 }}>
          <thead>
            <tr>
              <th></th>
              <th className="text-center">
                <input
                  className="report-checkbox"
                  type="checkbox"
                  checked={allMapSelected}
                  ref={el => {
                    if (el) el.indeterminate = someMapSelected;
                  }}
                  onChange={handleSelectAllMap}
                />
              </th>
              <th>Order</th>
              <th>Image</th>
              <th>Date</th>
              {/* <th>Picture Type</th> */}
              <th>Description</th>
            </tr>
          </thead>
          <ReactSortable
            tag="tbody"
            list={picturesWithMap}
            setList={(newList) => {
              // Update sort_order for each row based on its new position
              const updated = newList.map((item, idx) => ({ ...item, sort_order: idx + 1 }));
              setPicturesWithMap(updated);
            }}
            handle=".drag-handle"
            animation={150}
          >
            {
            picturesWithMap.map((pic, index) => (
              <tr key={pic.id} data-id={pic.id}>
                <td style={{ width: 32, textAlign: "center", cursor: "grab" }}>
                  <span className="drag-handle">
                    <img src={dragHandleIcon} alt="drag" style={{ width: 20, opacity: 0.7 }} />
                  </span>
                </td>
                <td style={{ width: 32, textAlign: "center" }}>
                  <input
                    className="report-checkbox"
                    type="checkbox"
                    checked={selectedMapPictureIds.includes(pic.id)}
                    onChange={() => handleSelectPictureMap(pic.id)}
                  />
                </td>
                <td style={{ width: 50 }}>{index + 1}</td>
                <td style={{ width: 100 }}>
                  {pic.image_url ? (
                    <a href={pic.image_url} target="_blank" rel="noopener noreferrer">
                      <img
                        src={pic.image_url}
                        alt="preview"
                        style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 4, border: '1px solid #ccc' }}
                      />
                    </a>
                  ) : (
                    <span className="text-muted">No Image</span>
                  )}
                </td>
                <td style={{ width: 100 }}>
                  <DatePicker
                    placeholderText="MM/DD/YYYY"
                    selected={pic.taken_on ? new Date(pic.taken_on) : null}
                    onChange={(date) => handleDateChangeForMapPictures(date, pic.id)}
                    dateFormat="MM/dd/yyyy"
                    aria-label="Date"
                    className="input-field w-100 mb-0 h-30"
                  />
                </td>
                {/* <td style={{ width: 100 }}>
                  <Select
                    value={pictureTypeOptions.find((opt) => opt.value === pic.type)}
                    options={pictureTypeOptions}
                    onChange={(val) => handlePictureTypeChange(pic.id, val)}
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
                </td> */}
                <td style={{ width: 400 }}>
                  <textarea
                    style={{
                      resize: 'none', height: '100px', borderRadius: '4px'
                    }}
                    className="form-control "
                    value={pic.comment || ''}
                    onChange={(e) => handleDescriptionChangeForMapPictures(pic.id, e.target.value)}
                    rows={1}
                  />
                </td>
              </tr>
            ))
            }
          </ReactSortable>
        </table>
        {getPlaceHolderText() && (
          <div className="report-table-placeholder">{getPlaceHolderText()}</div>
        )}
        </div>
      </section>
    </div>
  );
};

export default UnitJobReport;